import Link from 'next/link';

import { Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ShareContent } from 'src/components/basicContent/_shareContent/ShareContent';
import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import { RelatedContentFields, ShareContentFields } from '../ContentOverviewRelatedResourcesCourses';

import styles from './ContentOverviewRelatedResourcesCourses.module.css';

type ContentOverviewRelatedResourcesCoursesCardProps = ShareContentFields & {
	relatedContent?: RelatedContentFields;
};

export default function ContentOverviewRelatedResourcesCoursesCard(props: ContentOverviewRelatedResourcesCoursesCardProps): JSX.Element {
	const url = process.env.NEXT_PUBLIC_DEFAULT_SEARCH_PATH + '/' + props.relatedContent?.name.split(' ').join('-').toLowerCase();

	if (!props.relatedContent) {
		<></>;
	}

	const relatedContent = props.relatedContent?.fields;

	const imageSrc =
		relatedContent?.Image?.value?.src ||
		relatedContent?.['Background Image']?.value?.src ||
		relatedContent?.PageImage?.value?.src ||
		'/icons/Fallback-Image.png';

	const imageAlt =
		relatedContent?.Image?.value?.alt ||
		relatedContent?.Title?.value ||
		relatedContent?.PageTitle?.value ||
		relatedContent?.PageImage?.value?.alt;

	return (
		<div className={styles.contentOverviewCard}>
			<EditorHelp text="Please use image with minimum 340px width and 17:11 aspect ratio (e.g. 300x200px)." />
			<div className={styles.contentOverviewCardImageContainer}>
				<Link href={url}>
					<a>
						<img src={imageSrc} loading="lazy" className={styles.contentOverviewCardImage} alt={imageAlt} />;
					</a>
				</Link>
			</div>
			<div className={styles.contentOverviewCardContent}>
				<Text tag="a" href={url} field={relatedContent?.Title || relatedContent?.PageTitle} className={styles.contentOverviewCardTitle} />

				<ShareContent
					shareButtonToolTip={props.ShareButtonToolTip}
					shareOptions={props.ShareOptions}
					noShareOptions={props.NoShareOptions}
					shareTitle={props.relatedContent?.name || ''}
					shareUrl={url}
					itemId={props.relatedContent?.id}
					showText={false}
					favouriteButtonText={props.FavouriteButtonText}
					unfavouriteText={props.UnfavouriteText}
					flexEnd
				/>
			</div>
		</div>
	);
}
